import React, { useState, useEffect, useRef } from "react";
import { useNavigate } from "react-router-dom";
import FileSaver from "file-saver";
import * as XLSX from "xlsx";
import jsPDF from "jspdf";
import "jspdf-autotable";
import "./TableCompoenent.css";
import { FaFileCsv, FaFilePdf, FaFileExcel } from "react-icons/fa6";
import FileExport from "../../../Assets/Images/CommanImages/fileexport.png";
import Filter from "../../../Assets/Images/CommanImages/filter.png";
import columnaddition from "../../../Assets/Images/CommanImages/rectangleplus.png";
import searchicon from "../../../Assets/Images/CommanImages/searchyellow.png";
import updown from "../../../Assets/Images/CommanImages/updown.png";
import print from "../../../Assets/Images/CommanImages/print.png";
import cross from "../../../Assets/Images/CommanImages/cross_cancel.png";
import upimg from "../../../Assets/Images/CommanImages/up_arrow.png";
import downimg from "../../../Assets/Images/CommanImages/down_arrow.png";
import leftArrow from "../../../Assets/Images/CommanImages/Larrowbar.png";
import rightArrow from "../../../Assets/Images/CommanImages/Rarrowbar.png";
import reportImg from "../../../Assets/Images/client_logos/Reports/report_logo.png"
import watermarkImg from "../../../Assets/Images/client_logos/Reports/water_mark_img.png"
import "../../StudentRegistration/StudentRegistrationDashboard/studentdashboard.css";
import femaleImg from "../../../Assets/Images/Landing/female_01.png";
import maleImge from "../../../Assets/Images/Landing/male_01.png";

const TableCompoenent = ({
  headers,
  data,
  searchPlaceholder,
  children,
  isColumnDivVisible,
  setIsColumnDivVisible,
  dataClient,
  isExpanded, 
  ReportPageHeader,
  course, batch, student, subject, dppName, date, chapter, test, feedback
}) => {
  const navigate = useNavigate();
  const [searchQuery, setSearchQuery] = useState("");
  const userName = dataClient?.client_schema_name?.[6]?.[0]?.user_name || "Unknown User";
  const [isFilterVisible, setIsFilterVisible] = useState(false);
  const [visibleColumns, setVisibleColumns] = useState([]);
  const [sortConfig, setSortConfig] = useState({ key: null, direction: "asc" });
  const [isModalVisible, setIsModalVisible] = useState(false);
  const [currentPage, setCurrentPage] = useState(1);
  const [pageSize, setPageSize] = useState(10);
  const [isSearchModalVisible, setIsSearchModalVisible] = useState(false);
  const [searchResults, setSearchResults] = useState([]);
  const [currentSearchIndex, setCurrentSearchIndex] = useState(0);
  const modalRef = useRef(null);
  const columnDivRef = useRef(null);

  useEffect(() => {
    const handleClickOutside = (event) => {
      if (modalRef.current && !modalRef.current.contains(event.target)) {
        setIsModalVisible(false);
      }
      if (
        columnDivRef.current &&
        !columnDivRef.current.contains(event.target)
      ) {
        setIsColumnDivVisible(false); // Close the column div without resetting columns
      }
    };
  
    document.addEventListener("mousedown", handleClickOutside);
    return () => {
      document.removeEventListener("mousedown", handleClickOutside);
    };
  }, [setIsModalVisible, setIsColumnDivVisible]);

  useEffect(() => {
    if (headers.length > 0 && visibleColumns.length === 0) {
      // Get first 6 columns (indices 0-5), excluding Student ID and Gender ID
      const columnsToShow = headers
        .filter(h => h !== "Student ID" && h !== "Gender ID")
        .slice(0, 6);
      setVisibleColumns(columnsToShow);
    }
  }, [headers, visibleColumns]);


  const sortedData = React.useMemo(() => {
    let sortableData = [...data];
    if (sortConfig.key !== null) {
      sortableData.sort((a, b) => {
        const colIndex = headers.indexOf(sortConfig.key);
        if (a[colIndex] < b[colIndex]) {
          return sortConfig.direction === "asc" ? -1 : 1;
        }
        if (a[colIndex] > b[colIndex]) {
          return sortConfig.direction === "asc" ? 1 : -1;
        }
        return 0;
      });
    }
    return sortableData;
  }, [data, sortConfig, headers]);

  // const requiredColumns = ["Student Name", "Total Marks", "Rank", "Botany", "Chemistry", "Physics", "Zoology", "Maths"];

  // const handleColumnSelection = (column) => {
  //   if (visibleColumns.includes(column)) {
  //     // Remove the column
  //     setVisibleColumns(visibleColumns.filter((col) => col !== column));
  //   } else {
  //     // Add the column - if it's Photo, add it at the beginning, otherwise at the end
  //     if (column === "Photo") {
  //       setVisibleColumns(["Photo", ...visibleColumns]);
  //     } else {
  //       setVisibleColumns([...visibleColumns, column]);
  //     }
  //   }
  // };

  const handleColumnSelection = (column) => {
    // if (requiredColumns.includes(column)) return;

    if (visibleColumns.includes(column)) {
      setVisibleColumns(visibleColumns.filter((col) => col !== column));
    } else {
      if (column === "Photo") {
        setVisibleColumns(["Photo", ...visibleColumns]);
      } else {
        setVisibleColumns([...visibleColumns, column]);
      }
    }
  };

  const handleSort = (column) => {
    let direction = "asc";
    if (sortConfig.key === column && sortConfig.direction === "asc") {
      direction = "desc";
    }
    setSortConfig({ key: column, direction });
  };

  const handleExportClick = () => {
    if (data.length > 0) {
      setIsModalVisible(true);
    }
  };

  const handleColumnDivClick = () => {
    if (data.length > 0) {
      setIsColumnDivVisible(!isColumnDivVisible);
    }
  };

  // SHASHI CODE handleExport 
  const handleExport = (type) => {
    const exportData = sortedData.map((row) =>
      visibleColumns.map((column) => row[headers.indexOf(column)])
    );
  
    // if (type === "excel" || type === "csv") {
    //   const worksheet = XLSX.utils.aoa_to_sheet([
    //     visibleColumns, // Ensure that the columns are exported in the correct order
    //     ...exportData,
    //   ]);


      if (type === "excel" || type === "csv") {
        // Exclude "Photo" column for Excel and CSV exports
        const exportColumns = visibleColumns.filter((col) => col !== "Photo");
        const filteredExportData = sortedData.map((row) =>
          exportColumns.map((column) => row[headers.indexOf(column)])
        );

        const worksheet = XLSX.utils.aoa_to_sheet([
          exportColumns,
          ...filteredExportData,
        ]);
      const workbook = XLSX.utils.book_new();
      XLSX.utils.book_append_sheet(workbook, worksheet, "Sheet1");
  
      const fileExtension = type === "csv" ? "csv" : "xlsx";
      const mimeType =
        type === "csv"
          ? "text/csv"
          : "application/vnd.openxmlformats-officedocument.spreadsheetml.sheet";
  
      const file = XLSX.write(workbook, {
        bookType: fileExtension,
        type: "array",
      });
      const blob = new Blob([file], { type: mimeType });
  
      // Trigger "Save As" dialog with a default file name (browser settings dependent)
      FileSaver.saveAs(blob, `${ReportPageHeader}.${fileExtension}`);
    } else if (type === "pdf") {
      const doc = new jsPDF();
      doc.autoTable({
        head: [visibleColumns], // Use the visible columns for the PDF header
        body: exportData,
      });
      doc.save(`${ReportPageHeader}.pdf`);
    }
  };

  // const getStudentInitials = (studentName) => {
  //   if (!studentName || studentName === "---") return "NA";
  //   const parts = studentName.split(',').map(part => part.trim());
  //   if (parts.length === 2) {
  //     const lastName = parts[0];
  //     const firstName = parts[1];
  //     return (firstName.charAt(0) + lastName.charAt(0)).toUpperCase();
  //   }
  //   return studentName.substring(0, 2).toUpperCase();
  // };


  const getGenderAvatar = (originalRow) => {
  const genderIdIndex = headers.indexOf("Gender ID");
  const genderId = originalRow[genderIdIndex];
  return genderId === 1 ? maleImge : femaleImg; // 2 and 3 both female
};


  // Convert avatar images to base64 for print use
  const [maleBase64, setMaleBase64] = useState('');
  const [femaleBase64, setFemaleBase64] = useState('');

  useEffect(() => {
    const toBase64 = (src) => new Promise((resolve) => {
      const img = new Image();
      img.crossOrigin = 'anonymous';
      img.onload = () => {
        const canvas = document.createElement('canvas');
        canvas.width = img.width;
        canvas.height = img.height;
        canvas.getContext('2d').drawImage(img, 0, 0);
        resolve(canvas.toDataURL('image/png'));
      };
      img.onerror = () => resolve(''); 
      img.src = src;
    });

    toBase64(maleImge).then(setMaleBase64);
    toBase64(femaleImg).then(setFemaleBase64);
  }, []);

    const handleSaveAndPrint = () => {
      const exportData = sortedData.map((row) =>
        visibleColumns.map((column) => row[headers.indexOf(column)])
      );
      const currentDate = new Date();
      const formattedDate = currentDate.toLocaleDateString('en-GB', {
        year: 'numeric',
        month: '2-digit',
        day: '2-digit'
      });
      const formattedTime = currentDate.toLocaleTimeString('en-US', {
        hour: 'numeric',
        minute: '2-digit',
        hour12: true
      });
      const formattedDateTime = `${formattedDate}, ${formattedTime}`;

      const availablePageHeight = 630;
      const headerHeight = 150;
      const footerHeight = 50;

      const hasPhotoColumn = visibleColumns.includes("Photo");
      const rowHeight = hasPhotoColumn ? 50 : 20;

      const pageHeightForData = availablePageHeight - headerHeight - footerHeight;
      const rowsPerPage = Math.floor(pageHeightForData / rowHeight);

      const totalPages = Math.ceil(sortedData.length / rowsPerPage);

      const photoColIndex = visibleColumns.indexOf("Photo");

      // const renderPrintCell = (cell, colIdx, originalRow) => {
      //   if (colIdx === photoColIndex) {
      //     const isValidUrl =
      //       cell &&
      //       cell !== "---" &&
      //       (cell.startsWith("http://") || cell.startsWith("https://"));

      //     const studentNameIndex = headers.indexOf("Student Name");
      //     const studentName = originalRow[studentNameIndex];
      //     const initials = getStudentInitials(studentName);

      //     if (isValidUrl) {
      //       return `<td style="text-align:center;padding:2px;vertical-align:middle;">
      //         <img src="${cell}" alt="Photo"
      //           style="width:52px;height:60px;object-fit:contain;object-position:top center;border-radius:4px;display:block;margin:auto;"
      //           onerror="this.style.display='none';this.nextSibling.style.display='flex';" />
      //         <div style="display:none;width:48px;height:48px;background:#e0e0e0;border-radius:4px;
      //           align-items:center;justify-content:center;font-size:14px;font-weight:600;color:#666;
      //           text-align:center;flex-direction:column;margin:auto;">
      //           ${initials}
      //         </div>
      //       </td>`;
      //     } else {
      //       return `<td style="text-align:center;padding:2px;vertical-align:middle;">
      //         <div style="width:48px;height:48px;background:#e0e0e0;border-radius:4px;
      //           display:flex;align-items:center;justify-content:center;font-size:14px;font-weight:600;
      //           color:#666;text-align:center;flex-direction:column;margin:auto;">
      //           ${initials}
      //         </div>
      //       </td>`;
      //     }
      //   }
      //   return `<td style="text-align:left;padding:4px;">${cell !== null && cell !== undefined ? cell : ''}</td>`;
      // };


      const renderPrintCell = (cell, colIdx, originalRow) => {
        if (colIdx === photoColIndex) {
          const isValidUrl =
            cell &&
            cell !== "---" &&
            (cell.startsWith("http://") || cell.startsWith("https://"));

          const genderIdIndex = headers.indexOf("Gender ID");
          const genderId = originalRow[genderIdIndex];
          // Use base64 versions for print — module paths don't work in injected HTML
          const avatarSrc = genderId === 1 ? maleBase64 : femaleBase64;

          if (isValidUrl) {
            return `<td style="text-align:center;padding:2px;vertical-align:middle;">
              <img src="${cell}" alt="Photo"
                style="width:52px;height:60px;object-fit:contain;object-position:top center;border-radius:4px;display:block;margin:auto;"
                onerror="this.style.display='none';${avatarSrc ? `this.nextSibling.style.display='block';` : ''}" />
              ${avatarSrc ? `<img src="${avatarSrc}" alt="Avatar"
                style="display:none;width:48px;height:48px;object-fit:cover;display:none;margin:auto;" />` : ''}
            </td>`;
          } else {
            // No real photo — show gender avatar using base64
            return `<td style="text-align:center;padding:2px;vertical-align:middle;">
              ${avatarSrc
                ? `<img src="${avatarSrc}" alt="Avatar"
                    style="width:48px;height:48px;object-fit:cover;display:block;margin:auto;" />`
                : `<div style="width:48px;height:48px;display:block;margin:auto;"></div>`
              }
            </td>`;
          }
        }
        return `<td style="text-align:left;padding:4px;">${cell !== null && cell !== undefined ? cell : ''}</td>`;
      };

      const printSection = document.createElement('div');
      printSection.id = 'printSection';

      let printContent = `
        <style>
          body { margin: 0; padding: 0; font-family: 'Calibri', sans-serif; }
          table { width: 100%; border-collapse: collapse; table-layout: fixed; background-color: rgba(255, 255, 255, 0.5); font-size: 10px; margin-top: 6mm; }
          th, td { border: 1px solid black; padding: 4px; text-align: center; word-wrap: break-word; font-size: 10px; word-break: break-all; }
          th { font-size: 11px; font-weight: bold; background-color: #f2f2f2; }
          .Heading-tc { background-color: #f2f2f2; }
          .header-container { display: flex; justify-content: space-between; align-items: end; margin-bottom: 14px; border-bottom: 1.6px solid #424242; }
          .center-header { text-align: center; font-size: 18px; font-weight: bold; flex-grow: 1; color: #424242; }
          .logo { width: 140px; height: auto; margin-top: 10px; }
          .right-info { font-size: 10px; }
          .course-title { font-size: 14px; }
          .username { text-transform: uppercase; }
          .title-container p { margin-top: 1mm; }
          .title-label { color: #424242; font-size: 14px; }
          .transparent-table { background-color: rgba(255, 255, 255, 0.5); }
          .watermark {
            position: fixed;
            top: 50%;
            left: 50%;
            transform: translate(-50%, -50%);
            z-index: -1;
            pointer-events: none;
            opacity: 0.1;
          }
          .watermark img { width: auto; height: 200px; }
          .page-block { page-break-after: always; page-break-inside: avoid; }
          .page-block:last-child { page-break-after: auto; }
          @media print {
            body * { visibility: hidden; }
            #printSection, #printSection * { visibility: visible; }
            #printSection { position: absolute; left: 0; top: 0; width: 100%; padding: 10mm; }
            .page-block { page-break-after: always; page-break-inside: avoid; }
            .page-block:last-child { page-break-after: auto; }
          }
          @page { size: auto; margin: 5mm; }
        </style>
      `;

      printContent += `<div class="watermark"><img src="${watermarkImg}" alt="Watermark" /></div>`;

      const buildHeader = (pageNum) => `
        <div class="header-container">
          <img class="logo" src="${reportImg}" alt="Logo" />
          <h1 class="center-header">${test}</h1>
          <div class="right-info">
            <p>Print Date&nbsp;&nbsp;: ${formattedDateTime}</p>
            <p>Printed By&nbsp;: <span class="username">${userName}</span></p>
            <p>Page ${pageNum} of ${totalPages}</p>
          </div>
        </div>
      `;

      const tableHeader = `
        <thead>
          <tr>${visibleColumns.map((heading) => `<th class="Heading-tc">${heading}</th>`).join('')}</tr>
        </thead>
      `;

      for (let page = 1; page <= totalPages; page++) {
        const startIndex = (page - 1) * rowsPerPage;
        const endIndex = Math.min(startIndex + rowsPerPage, sortedData.length);
        const pageRows = sortedData.slice(startIndex, endIndex);
        const pageExportRows = exportData.slice(startIndex, endIndex);

        const isFirstPage = page === 1;

        printContent += `
          <div class="page-block">
            ${buildHeader(page)}
            ${isFirstPage ? `
            <div class="title-container">
              <p><span class="title-label">Course:</span><span class="course-title"> ${course}</span></p>
              <p><span class="title-label">Batch:</span><span class="course-title"> ${batch}</span></p>
              ${subject ? `<p><span class="title-label">Subject:</span><span class="course-title"> ${subject}</span></p>` : ''}
              ${chapter ? `<p><span class="title-label">Chapter:</span><span class="course-title"> ${chapter}</span></p>` : ''}
              ${student ? `<p><span class="title-label">Student:</span><span class="course-title"> ${student}</span></p>` : ''}
              ${dppName ? `<p><span class="title-label">DPP Name:</span><span class="course-title"> ${dppName}</span></p>` : ''}
              ${feedback ? `<p><span class="title-label">Feedback:</span><span class="course-title"> ${feedback}</span></p>` : ''}
              ${test ? `<p><span class="title-label">Test:</span><span class="course-title"> ${test}</span></p>` : ''}
              ${date ? `<p><span class="title-label">Date:</span><span class="course-title"> ${date}</span></p>` : ''}
            </div>` : ''}
            <table class="transparent-table">
              ${tableHeader}
              <tbody>
                ${pageRows.map((originalRow, idx) => {
                  const exportRow = pageExportRows[idx];
                  return `<tr>${exportRow.map((cell, colIdx) => renderPrintCell(cell, colIdx, originalRow)).join('')}</tr>`;
                }).join('')}
              </tbody>
            </table>
          </div>
        `;
      }

      printSection.innerHTML = printContent;
      document.body.appendChild(printSection);

      const printStyles = document.createElement('style');
      printStyles.innerHTML = `
        @media print {
          body * { visibility: hidden; }
          #printSection, #printSection * { visibility: visible; }
          #printSection { position: absolute; left: 0; top: 0; width: 100%; padding: 10mm; }
        }
        @page { size: auto; margin: 5mm; }
      `;
      document.head.appendChild(printStyles);

      const logo = new Image();
      logo.src = reportImg;
      logo.onload = () => {
        window.print();
        document.body.removeChild(printSection);
        document.head.removeChild(printStyles);
      };
    };


    const handlePageSizeChange = (size) => {
      setPageSize(size);
      setCurrentPage(1); // Reset to the first page
    };

  const handlePageChange = (page) => {
    setCurrentPage(page);
  };

  const totalPages = Math.ceil(sortedData.length / pageSize);
  const paginatedData = React.useMemo(() => {
    const startIndex = (currentPage - 1) * pageSize;
    return sortedData.slice(startIndex, startIndex + pageSize);
  }, [sortedData, currentPage, pageSize]);

  const renderPagination = () => {
    const pages = [];
    if (totalPages <= 5) {
      for (let i = 1; i <= totalPages; i++) {
        pages.push(
          <button
            key={i}
            onClick={() => handlePageChange(i)}
            style={{ borderRadius: "5px" }}
            className={i === currentPage ? "active" : ""}
          >
            {i}
          </button>
        );
      }
    } else {
      if (currentPage <= 3) {
        for (let i = 1; i <= 3; i++) {
          pages.push(
            <button
              key={i}
              style={{ borderRadius: "5px" }}
              onClick={() => handlePageChange(i)}
              className={i === currentPage ? "active" : ""}
            >
              {i}
            </button>
          );
        }
        pages.push(
          <span style={{ borderRadius: "5px" }} key="dots1">
            ...
          </span>
        );
        pages.push(
          <button
            key={totalPages}
            onClick={() => handlePageChange(totalPages)}
            style={{ borderRadius: "5px" }}
          >
            {totalPages}
          </button>
        );
      } else if (currentPage > 3 && currentPage < totalPages - 2) {
        pages.push(
          <button
            key={1}
            onClick={() => handlePageChange(1)}
            style={{ borderRadius: "5px" }}
          >
            1
          </button>
        );
        pages.push(
          <span style={{ borderRadius: "5px" }} key="dots1">
            ...
          </span>
        );
        for (let i = currentPage - 1; i <= currentPage + 1; i++) {
          pages.push(
            <button
              key={i}
              onClick={() => handlePageChange(i)}
              style={{ borderRadius: "5px" }}
              className={i === currentPage ? "active" : ""}
            >
              {i}
            </button>
          );
        }
        pages.push(
          <span style={{ borderRadius: "5px" }} key="dots2">
            ...
          </span>
        );
        pages.push(
          <button
            key={totalPages}
            onClick={() => handlePageChange(totalPages)}
            style={{ borderRadius: "5px" }}
          >
            {totalPages}
          </button>
        );
      } else {
        pages.push(
          <button
            key={1}
            onClick={() => handlePageChange(1)}
            style={{ borderRadius: "5px" }}
          >
            1
          </button>
        );
        pages.push(
          <span style={{ borderRadius: "5px" }} key="dots1">
            ...
          </span>
        );
        for (let i = totalPages - 2; i <= totalPages; i++) {
          pages.push(
            <button
              key={i}
              onClick={() => handlePageChange(i)}
              style={{ borderRadius: "5px" }}
              className={i === currentPage ? "active" : ""}
            >
              {i}
            </button>
          );
        }
      }
    }
    return pages;
  };

  const handleSearch = (e) => {
    const query = e.target.value;
    setSearchQuery(query);
    setCurrentPage(1); // Reset to the first page on search


    if (query) {
      const results = [];
      data.forEach((row, rowIndex) => {
        row.forEach((cell, cellIndex) => {
          // Check if the cell is not null or undefined
          if (
            cell !== null &&
            cell !== undefined &&
            cell.toString().toLowerCase().includes(query.toLowerCase()) &&
            cell !== null &&
            cell !== undefined &&
            cell.toString().toLowerCase().includes(query.toLowerCase()) &&
            visibleColumns.includes(headers[cellIndex])
          ) {
            results.push({ rowIndex, cellIndex });
          }
        });
      });
      setSearchResults(results);
      setCurrentSearchIndex(0);
    } else {
      setSearchResults([]);
    }
    setIsSearchModalVisible(true); // Open the search modal
  };

  const highlightText = (text, highlight, isCurrent) => {
    if (!highlight) return text;

    // Convert the text to a string if it isn't one already
    const textStr = text != null ? text.toString() : "";

    const regex = new RegExp(`(${highlight})`, "gi");
    return textStr.split(regex).map((part, index) =>
      part.toLowerCase() === highlight.toLowerCase() ? (
        <span
          key={index}
          style={{ backgroundColor: isCurrent ? "yellow" : "#FFD700" }} // Yellow for current, Dark Yellow for others
        >
          {part}
        </span>
      ) : (
        part
      )
    );
  };

  const moveToNextResult = () => {
    if (searchResults.length === 0) return;

    setCurrentSearchIndex((prevIndex) => {
      const nextIndex =
        prevIndex + 1 < searchResults.length ? prevIndex + 1 : prevIndex;
      const nextResult = searchResults[nextIndex];

      const nextPage = Math.floor(nextResult.rowIndex / pageSize) + 1;

      if (nextPage !== currentPage) {
        setCurrentPage(nextPage);
      }

      return nextIndex;
    });
  };

  const moveToPreviousResult = () => {
    if (searchResults.length === 0) return;

    setCurrentSearchIndex((prevIndex) => {
      const prevIndexAdjusted = prevIndex - 1 >= 0 ? prevIndex - 1 : prevIndex;
      const prevResult = searchResults[prevIndexAdjusted];

      const prevPage = Math.floor(prevResult.rowIndex / pageSize) + 1;

      if (prevPage !== currentPage) {
        setCurrentPage(prevPage);
      }

      return prevIndexAdjusted;
    });
  };

  return (
    <div>
      <div>
        <div
          className="search-and-pagination-wrapper"
          style={{
            display: "flex",
            alignItems: "center",
            justifyContent: "end",
          }}
        >
          <div
            className="search-wrapper"
            style={{
              display: "flex",
              alignItems: "center",
              justifyContent: "end",
            }}
          >
            <div className="pagination-info">
              Displaying{" "}
              {Math.min((currentPage - 1) * pageSize + 1, sortedData.length)} -{" "}
              {Math.min(currentPage * pageSize, sortedData.length)} of{" "}
              {sortedData.length} records |
              {["10", "25", "50", "100", "500"].map((size) => (
                <span
                  key={size}
                  onClick={() => handlePageSizeChange(Number(size))}
                  style={{
                    cursor: "pointer",
                    margin: "0 5px",
                    textDecoration:
                      size === pageSize.toString() ? "none" : "underline",
                    color: size === pageSize.toString() ? "black" : "#337AB7",
                  }}
                >
                  {size}
                </span>
              ))}
            </div>
          </div>
        </div>
        <div
          className="row-tc"
          style={{
            backgroundColor: "#D6D6D6",
            marginTop: "5px",
            borderTop: "1px solid grey",
            borderBottom: "1px solid grey",
          }}
        >
          <div
            className="col-cs2-TABLE"
            style={{
              backgroundColor: "#FFBD20",
              display: "flex",
              alignItems: "center",
              cursor: data.length > 0 ? "pointer" : "not-allowed",
              paddingLeft: "8px",
            }}
          // onClick={handleFilterClick}
          >
            <img
              src={Filter}
              style={{ height: "25px", width: "25px" }}
              alt="filter"
            />
            <span style={{ marginLeft: "10px", color: "#2F2E40" }}>
              Advance Filter
            </span>
          </div>
          <div
            className="col-cs"
            style={{
              display: "flex",
              alignItems: "center",
              cursor: data.length > 0 ? "pointer" : "not-allowed",
            }}
          >
            <div
              style={{
                display: "flex",
                alignItems: "center",
              }}
              onClick={handleExportClick}
            >
              <img
                src={FileExport}
                style={{ height: "25px", width: "25px" }}
                alt="export"
              />
              <span style={{ marginLeft: "10px", color: "#2F2E40" }}>
                Export
              </span>
            </div>
            {isModalVisible && (
              <div
                ref={modalRef}
                style={{ position: "relative", display: "inline-block" }}
              >
                <div className="arrow-up-tc-2"></div>
                <div className="modal-tc-2">
                  <div className="modal-content-tc-2">
                    <button
                      onClick={() => [
                        handleExport("excel"),
                        setIsModalVisible(false),
                      ]}
                    >
                      <FaFileExcel className="Img-EXCEL" />
                      <span style={{ fontSize: "14px" }}>Excel</span>
                    </button>
                    <button
                      onClick={() => [
                        handleExport("csv"),
                        setIsModalVisible(false),
                      ]}
                    >
                      <FaFileCsv className="Img-CSV" />
                      <span style={{ fontSize: "14px" }}>CSV</span>
                    </button>
                    {/* <button
                      onClick={() => [
                        handleExport("pdf"),
                        setIsModalVisible(false),
                      ]}
                    >
                      <FaFilePdf className="Img-PDF" />
                      <span style={{ fontSize: "14px" }}>PDF</span>
                    </button> */}
                  </div>
                </div>
              </div>
            )}
            <div
              className="col-cs"
              style={{
                display: "flex",
                alignItems: "center",
                cursor: data.length > 0 ? "pointer" : "not-allowed",
              }}
            >
              <div
                onClick={() =>
                  data.length > 0 && [
                    handleSaveAndPrint(),
                    setIsModalVisible(false),
                  ]
                }
                style={{ display: "flex", alignItems: "center" }}
              >
                <img src={print} alt="print" />
                <span style={{ marginLeft: "10px", color: "#2F2E40" }}>
                  Print
                </span>
              </div>
            </div>
          </div>
          <div
            className="col-tc"
            onClick={() => setIsSearchModalVisible(!isSearchModalVisible)}
          >
            <img
              src={searchicon}
              style={{ height: "25px", width: "25px" }}
              alt="search"
            />
            <span style={{ marginLeft: "10px", color: "#2F2E40" }}>Search</span>
          </div>
          {isSearchModalVisible && (
            <div>
              <div className="inside-search-table-items">
                <div className="inside-table-search-items">
                  <div className="search-input-container">
                    <input
                      type="text"
                      placeholder="Search..."
                      name="search"
                      value={searchQuery}
                      onChange={handleSearch}
                    />
                  </div>
                  <div className="search-results-container">
                    <span style={{ width: "65px" }}>
                      {searchResults.length > 0
                        ? `${currentSearchIndex + 1} of ${searchResults.length}`
                        : ""}
                    </span>
                  </div>
                  <div className="button-container">
                    <img
                      src={upimg}
                      alt="up"
                      onClick={moveToPreviousResult}
                      style={{
                        filter:
                          currentSearchIndex > 0
                            ? "invert(48%) sepia(0%) saturate(0%) hue-rotate(0deg) brightness(75%) contrast(90%)"
                            : "brightness(0.5) invert(0.5)",
                        cursor:
                          currentSearchIndex > 0 ? "pointer" : "not-allowed",
                      }}
                      disabled={
                        searchResults.length === 0 || currentSearchIndex === 0
                      }
                    />
                    <img
                      src={downimg}
                      alt="down"
                      onClick={moveToNextResult}
                      style={{
                        filter:
                          currentSearchIndex < searchResults.length - 1
                            ? "invert(48%) sepia(0%) saturate(0%) hue-rotate(0deg) brightness(75%) contrast(90%)"
                            : "brightness(0.5) invert(0.5)",
                        cursor:
                          currentSearchIndex < searchResults.length - 1
                            ? "pointer"
                            : "not-allowed",
                      }}
                      disabled={
                        searchResults.length === 0 ||
                        currentSearchIndex === searchResults.length - 1
                      }
                    />
                    <span
                      onClick={() => {
                        setSearchQuery("");
                        setSearchResults([]); // Clear search results
                        setCurrentSearchIndex(0); // Reset search index
                        setIsSearchModalVisible(false);
                      }}
                    >
                      <img src={cross} alt="cross" />
                    </span>
                  </div>
                </div>
              </div>
            </div>
          )}
          <div
            ref={columnDivRef}
            className="col-tc"
            style={{
              textAlign: "end",
              marginRight: "8px",
              display: "flex",
              alignItems: "center",
              position: "relative",
              cursor: data.length > 0 ? "pointer" : "not-allowed",
            }}
            onClick={handleColumnDivClick}
          >
            <img
              src={columnaddition}
              style={{ height: "25px", width: "25px" }}
              alt="column addition"
            />
            <span style={{ marginLeft: "10px", color: "#2F2E40" }}>
              Column Selection
            </span>
            {isColumnDivVisible && (
              <>
                <div className="arrow-up-tc"></div>
                <div className="popupColumn-tc">
                  {/* {headers
                    .filter((column) => column !== "Student ID") // Filter out Student ID
                    .map((column, index) => (
                      <div
                        key={index}
                        onClick={(e) => {
                          e.stopPropagation(); // Prevent closing of the columnDiv
                          handleColumnSelection(column);
                        }}
                      >
                        <input
                          type="checkbox"
                          id={`column-${index}`}
                          name="columnSelection"
                          value={column}
                          className="square-checkbox-tc"
                          checked={visibleColumns.includes(column)}
                          readOnly
                        />
                        <label
                          htmlFor={`column-${index}`}
                          style={{
                            marginLeft: "10px",
                            maxWidth: "110px",
                            whiteSpace: "nowrap",
                            overflow: "hidden",
                            textOverflow: "ellipsis",
                            display: "inline-block",
                          }}
                          title={column}
                        >
                          {column}
                        </label>
                      </div>
                    ))} */}
                    {headers
                    .filter((column) => column !== "Student ID" && column !== "Gender ID")
                    .map((column, index) => {
                      // const isRequired = requiredColumns.includes(column);
                      return (
                        <div
                          key={index}
                          onClick={(e) => {
                            e.stopPropagation();
                            handleColumnSelection(column);
                          }}
                          // style={{
                          //   cursor: isRequired ? "not-allowed" : "pointer",
                          //   opacity: isRequired ? 0.6 : 1,
                          // }}
                        >
                          <input
                            type="checkbox"
                            id={`column-${index}`}
                            name="columnSelection"
                            value={column}
                            className="square-checkbox-tc"
                            checked={visibleColumns.includes(column)}
                            // disabled={isRequired}
                            readOnly
                          />
                          <label
                            htmlFor={`column-${index}`}
                            style={{
                              marginLeft: "10px",
                              maxWidth: "110px",
                              whiteSpace: "nowrap",
                              overflow: "hidden",
                              textOverflow: "ellipsis",
                              display: "inline-block",
                              // cursor: isRequired ? "not-allowed" : "pointer",
                            }}
                            // title={isRequired ? `${column} (required)` : column}
                          >
                            {column}
                          </label>
                        </div>
                      );
                    })}
                </div>
              </>
            )}
          </div>
        </div>
        <div
          className="table-wrapper"

          style={{
            maxHeight: isExpanded ? "58.5vh" : "36vh",
            overflowY: "auto",
            overflowX: "auto",
            minWidth: "100%",
            maxWidth: "82.2vw",
            marginRight: "auto",
          }}
        >
          {data.length === 0 ? (
            <div style={{ textAlign: "center", marginTop: "20px" }}></div>
          ) : (
            <table className="table-tc" style={{ width: "100%" }}>
              <thead>
                <tr>
                  {visibleColumns.map((heading, index) => (
                    <th
                      onClick={() => handleSort(heading)}
                      className="Heading-tc"
                      key={index}
                      style={{
                        textAlign: "center",
                        cursor: "pointer",
                        position: "sticky",
                        top: "0",
                        zIndex: 2,
                        backgroundColor: "white",
                      }}
                    >
                      <span
                        style={{
                          display: "flex",
                          alignItems: "center",
                          justifyContent: heading === "Photo" ? "center" : "left",
                        }}
                      >
                        {heading}
                        <img
                          onClick={() => handleSort(heading)}
                          src={updown}
                          style={{
                            height: "20px",
                            width: "20px",
                            marginLeft: "5px",
                          }}
                          alt="sort"
                        />
                      </span>
                    </th>
                  ))}
                </tr>
              </thead>
              <tbody>
                {paginatedData.map((row, rowIndex) => (
                  <tr
                    key={rowIndex}
                    className={rowIndex % 2 === 1 ? "even-row-tc" : ""}
                  >
                    {visibleColumns.map((column) => {
                      const cellIndex = headers.indexOf(column);
                      const cellValue = row[cellIndex];
                      if (column === "Photo") {
                        const isValidUrl =
                          cellValue &&
                          cellValue !== "---" &&
                          (cellValue.startsWith("http://") || cellValue.startsWith("https://"));
                        const studentNameIndex = headers.indexOf("Student Name");
                        const studentName = row[studentNameIndex];
                        // const initials = getStudentInitials(studentName);

                        // return (
                        //   <td
                        //     key={column}
                        //     style={{ textAlign: "center", color: "#6A6A6A", padding: "6px 4px" }}
                        //   >
                        //     <div className="student-avatar-wrapper"
                        //       style={{ cursor: "pointer" }}
                        //         onClick={() => {
                        //           const studentId = row[headers.indexOf("Student ID")];
                        //           window.open(`/student_dashboard?studentId=${studentId}`, "_blank");
                        //         }}
                        //       title="View student dashboard">
                        //       {isValidUrl ? (
                        //         <>
                        //           <img
                        //             src={cellValue}
                        //             alt="Student"
                        //             className="student-avatar"
                        //             onError={(e) => {
                        //               e.currentTarget.style.display = "none";
                        //               e.currentTarget.nextSibling.style.display = "flex";
                        //             }}
                        //             style={{
                        //               width: "40px",
                        //               height: "40px",
                        //               borderRadius: "50%",
                        //               objectFit: "contain",   
                        //               objectPosition: "top center",  
                        //               background: "#f5f5f5"  
                        //             }}
                        //           />
                        //           <div className="student-avatar-placeholder"
                        //           style={{ 
                        //               display: "none",
                        //               width: "40px",
                        //               height: "40px",
                        //               borderRadius: "50%",
                        //               background: "#e0e0e0",
                        //               justifyContent: "center",
                        //               alignItems: "center",
                        //               fontSize: "13px",
                        //               fontWeight: "600",
                        //               color: "#666"
                        //             }}
                        //             >
                        //             {initials}
                        //           </div>
                        //         </>
                        //       ) : (
                        //         <div className="student-avatar-placeholder"
                        //         style={{
                        //             width: "40px",
                        //             height: "40px",
                        //             borderRadius: "50%",
                        //             background: "#e0e0e0",
                        //             display: "flex",
                        //             justifyContent: "center",
                        //             alignItems: "center",
                        //             fontSize: "13px",
                        //             fontWeight: "600",
                        //             color: "#666"
                        //           }}
                        //           >
                        //           {initials}
                        //         </div>
                        //       )}
                        //     </div>
                        //   </td>
                        // );

                        return (
                          <td
                            key={column}
                            style={{ textAlign: "center", color: "#6A6A6A", padding: "6px 4px" }}
                          >
                          <div
                          className="student-avatar-wrapper"
                          style={{ cursor: "pointer" }}  
                          onClick={() => {
                            // ✅ always navigate regardless of isValidUrl
                            const studentId = row[headers.indexOf("Student ID")];
                            window.open(`/student_dashboard?studentId=${studentId}`, "_blank");
                          }}
                          title="View student dashboard"
                        >
                          {isValidUrl ? (
                            <>
                              <img
                                src={cellValue}
                                alt="Student"
                                className="student-avatar"
                                onError={(e) => {
                                  e.currentTarget.style.display = "none";
                                  e.currentTarget.nextSibling.style.display = "block";
                                }}
                              />
                              {/* Fallback gender avatar on error */}
                              <img
                                src={getGenderAvatar(row)}
                                alt="Avatar"
                                className="student-avatar-placeholder student-avatar-fallback"
                                style={{ display: "none" }}
                              />
                            </>
                          ) : (
                            <img
                              src={getGenderAvatar(row)}
                              alt="Avatar"
                              className="student-avatar-placeholder"
                            />
                          )}
                        </div>
                          </td>
                        );

                      }
                      return (
                        <td
                          key={column}
                          style={{ textAlign: "left", color: "#6A6A6A" }}
                        >
                          {highlightText(
                            cellValue,
                            searchQuery,
                            searchResults.length > 0 &&
                            searchResults[currentSearchIndex]?.rowIndex === rowIndex &&
                            searchResults[currentSearchIndex]?.cellIndex === cellIndex
                          )}
                        </td>
                      );
                    })}
                  </tr>
                ))}
              </tbody>
            </table>
          )}
        </div>
        {data.length > 0 && totalPages > 1 && (
          <div className="pagination-tc">
            <button
              onClick={() => handlePageChange(1)}
              disabled={currentPage === 1}
              className="extreme-left-tc-pagination"
            >
              <img src={leftArrow} alt="left arrow" />
            </button>
            <button
              onClick={() => handlePageChange(currentPage - 1)}
              disabled={currentPage === 1}
              className="lefttc-pagination"
            >
              {"<"}
            </button>
            {renderPagination()}
            <button
              onClick={() => handlePageChange(currentPage + 1)}
              disabled={currentPage === totalPages}
              className="righttc-pagination"
            >
              {">"}
            </button>
            <button
              onClick={() => handlePageChange(totalPages)}
              disabled={currentPage === totalPages}
              className="extreme-right-tc-pagination"
            >
              <img src={rightArrow} alt="right arrow" />
            </button>
          </div>
        )}
        {isFilterVisible && (
          <div className="filter-sidebar-AdvanceFilter">
            <div className="filter-content-AdvanceFilter">
              <button
                className="repman-cross-btn"
                style={{
                  position: "absolute",
                  left: "-29px",
                  height: "40px",
                  width: "30px",
                  color: "white",
                  border: "none",
                  fontSize: "20px",
                  fontWeight: "700",
                  borderRadius: "5px 0px 0px 5px",
                }}
                onClick={() => {
                  setIsFilterVisible(false);
                }}
              >
                <p>X</p>
              </button>
              <h3 className="AdvanceF-heading-tc">Advance Filter</h3>
              {children}
            </div>
          </div>
        )}
      </div>
    </div>
  );
};

export default TableCompoenent;













// PRINT PAGE photo(DATE 31/03/2026)
  // const handleSaveAndPrint = () => {
  //   const exportData = sortedData.map((row) =>
  //     visibleColumns.map((column) => row[headers.indexOf(column)])
  //   );
  //   const currentDate = new Date();
  //   const formattedDate = currentDate.toLocaleDateString('en-GB', {
  //     year: 'numeric',
  //     month: '2-digit',
  //     day: '2-digit'
  //   });
  //   const formattedTime = currentDate.toLocaleTimeString('en-US', {
  //     hour: 'numeric',
  //     minute: '2-digit',
  //     hour12: true
  //   });
  //   const formattedDateTime = `${formattedDate}, ${formattedTime}`;

  //   const availablePageHeight = 630;
  //   const headerHeight = 150;
  //   const footerHeight = 50;
  //   const rowHeight = 20;
  //   const pageHeightForData = availablePageHeight - headerHeight - footerHeight;
  //   const rowsPerPage = Math.floor(pageHeightForData / rowHeight);

  //   const totalPages = Math.ceil(sortedData.length / rowsPerPage);

  //   const photoColIndex = visibleColumns.indexOf("Photo");

  //   // Modified renderPrintCell to accept full original row
  //   const renderPrintCell = (cell, colIdx, originalRow) => {
  //     if (colIdx === photoColIndex) {
  //       const isValidUrl =
  //         cell &&
  //         cell !== "---" &&
  //         (cell.startsWith("http://") || cell.startsWith("https://"));
        
  //       const studentNameIndex = headers.indexOf("Student Name");
  //       const studentName = originalRow[studentNameIndex];
  //       const initials = getStudentInitials(studentName);
        
  //       if (isValidUrl) {
  //         return `<td style="text-align:center;padding:4px;">
  //           <img src="${cell}" alt="Photo"
  //             style="width:60px;height:60px;object-fit:cover;border-radius:4px;"
  //             onerror="this.style.display='none';this.nextSibling.style.display='flex';" />
  //           <div style="display:none;width:60px;height:60px;background:#e0e0e0;border-radius:4px;
  //             align-items:center;justify-content:center;font-size:16px;font-weight:600;color:#666;text-align:center;
  //             flex-direction:column;margin:auto;">
  //             ${initials}
  //           </div>
  //         </td>`;
  //       } else {
  //         return `<td style="text-align:center;padding:4px;">
  //           <div style="width:60px;height:60px;background:#e0e0e0;border-radius:4px;
  //             display:flex;align-items:center;justify-content:center;font-size:16px;font-weight:600;
  //             color:#666;text-align:center;flex-direction:column;margin:auto;">
  //             ${initials}
  //           </div>
  //         </td>`;
  //       }
  //     }
  //     return `<td>${cell !== null && cell !== undefined ? cell : ''}</td>`;
  //   };

  //   // Create a hidden print section in the body of the document
  //   const printSection = document.createElement('div');
  //   printSection.id = 'printSection';

  //   // Define print content with scaled styles for A4/Letter and watermark
  //   let printContent = `
  //     <style>
  //       body { margin: 0; padding: 0; font-family: 'Calibri', sans-serif; }
  //       table { width: 100%; border-collapse: collapse; table-layout: fixed; background-color: rgba(255, 255, 255, 0.5); font-size: 10px; margin-top: 6mm; }
  //       th, td { border: 1px solid black; padding: 4px; text-align: center; word-wrap: break-word; font-size: 10px; word-break: break-all; }
  //       th { font-size: 11px; font-weight: bold; background-color: #f2f2f2; }
  //       .Heading-tc { background-color: #f2f2f2; }
  //       .header-container { display: flex; justify-content: space-between; align-items: end; margin-bottom: 14px; border-bottom: 1.6px solid #424242; }
  //       .center-header { text-align: center; font-size: 18px; font-weight: bold; flex-grow: 1; color: #424242; }
  //       .logo { width: 140px; height: auto; margin-top: 10px; }
  //       .right-info { font-size: 10px; }
  //       .course-title  { font-size: 14px; }
  //       .username { text-transform: uppercase; }
  //       .title-container p { margin-top: 1mm; }
  //       .title-label { color: #424242; font-size: 14px; }
  //       .photo-col { width: 55px; }
  //       .transparent-table { background-color: rgba(255, 255, 255, 0.5); }
  //       footer { position: fixed; bottom: 0; width: 100%; text-align: right; font-size: 10px; }
  //       .watermark {
  //         position: fixed;
  //         top: 50%; 
  //         left: 50%;
  //         transform: translate(-50%, -50%);
  //         font-size: 48px;
  //         color: red; 
  //         z-index: -1;
  //         pointer-events: none;
  //         opacity: 0.1;
  //       }
  //       .watermark img{width: auto; height: 200px;}
  //       @media print {
  //         body * { visibility: hidden; }
  //         #printSection, #printSection * { visibility: visible; }
  //         #printSection { position: absolute; left: 0; top: 0; width: 100%; padding: 10mm; }
  //       }
  //       @page { size: auto; margin: 5mm; }
  //     </style>
  //   `;

  //   printContent += `<div class="watermark"><img src="${watermarkImg}" alt="Watermark" /></div>`;
  //   printContent += `
  //     <div class="first-page" style="page-break-after: always;">
  //       <div class="header-container">
  //         <img class="logo" src="${reportImg}" alt="Logo" />
  //         <h1 class="center-header">${ReportPageHeader}</h1>
  //         <div class="right-info">
  //           <p>Print Date&nbsp;&nbsp;: ${formattedDateTime}</p>
  //           <p>Printed By&nbsp;: <span class="username">${userName}</span></p>
  //           <p>Page 1 of ${totalPages}</p>
  //         </div>
  //       </div>
  //       <div class="title-container">
  //         <p><span class="title-label">Course:</span><span class="course-title"> ${course}</span></p>
  //         <p><span class="title-label">Batch:</span><span class="course-title"> ${batch}</span></p>
  //         ${subject ? `<p><span class="title-label">Subject:</span><span class="course-title"> ${subject}</span></p>` : ''}
  //         ${chapter ? `<p><span class="title-label">Chapter:</span><span class="course-title"> ${chapter}</span></p>` :  ''}
  //         ${student ? `<p><span class="title-label">Student:</span><span class="course-title"> ${student}</span></p>` : ''}
  //         ${dppName ? `<p><span class="title-label">DPP Name:</span><span class="course-title"> ${dppName}</span></p>` : ''} 
  //         ${feedback ? `<p><span class="title-label">Feedback:</span><span class="course-title"> ${feedback}</span></p>`: ''}
  //         ${test ? `<p><span class="title-label">Test:</span><span class="course-title"> ${test}</span></p>`: ''}
  //         ${date ? `<p><span class="title-label">Date:</span><span class="course-title"> ${date}</span></p>` : ''}
  //       </div>
  //       <table class="transparent-table">
  //         <thead>
  //           <tr>${visibleColumns.map((heading) => `<th class="Heading-tc">${heading}</th>`).join('')}</tr>
  //         </thead>
  //         <tbody>
  //           ${sortedData.slice(0, rowsPerPage).map((originalRow, idx) => {
  //             const exportRow = exportData[idx];
  //             return `<tr>${exportRow.map((cell, colIdx) => renderPrintCell(cell, colIdx, originalRow)).join('')}</tr>`;
  //           }).join('')}
  //         </tbody>
  //       </table>
  //     </div>
  //   `;

  //   // Additional pages
  //   for (let page = 2; page <= totalPages; page++) {
  //     const startIndex = (page - 1) * rowsPerPage;
  //     const endIndex = Math.min(startIndex + rowsPerPage, sortedData.length);

  //     printContent += `
  //     <div class="other-pages" style="page-break-after: always;">
  //       <div class="header-container">
  //         <img class="logo" src="${reportImg}" alt="Logo" />
  //         <h1 class="center-header">${ReportPageHeader}</h1>
  //         <div class="right-info">
  //           <p>Print Date&nbsp;&nbsp;: ${formattedDateTime}</p>
  //           <p>Printed By&nbsp;: <span class="username">${userName}</span></p>
  //           <p>Page ${page} of ${totalPages}</p>
  //         </div>
  //       </div>
  //       <table class="transparent-table">
  //         <thead>
  //           <tr>${visibleColumns.map((heading) => `<th class="Heading-tc">${heading}</th>`).join('')}</tr>
  //         </thead>
  //         <tbody>
  //           ${sortedData.slice(0, rowsPerPage).map((originalRow, idx) => {
  //             const exportRow = exportData[idx];
  //             return `<tr>${exportRow.map((cell, colIdx) => renderPrintCell(cell, colIdx, originalRow)).join('')}</tr>`;
  //           }).join('')}
  //         </tbody>
  //       </table>
  //     </div>
  //     `;
  //   }

  //   printSection.innerHTML = printContent;

  //   // Append this hidden section to the body
  //   document.body.appendChild(printSection);

  //   // Create a print media query to show only this section during printing
  //   const printStyles = document.createElement('style');
  //   printStyles.innerHTML = `
  //     @media print {
  //       body * { visibility: hidden; }
  //       #printSection, #printSection * { visibility: visible; }
  //       #printSection { position: absolute; left: 0; top: 0; width: 100%; padding: 10mm; }
  //     }

  //     @page {
  //       size: auto;
  //       margin: 5mm;
  //     }
  //   `;
  //   document.head.appendChild(printStyles);

  //   const logo = new Image();
  //   logo.src = reportImg;
  //   logo.onload = () => {
  //     window.print();
  //     document.body.removeChild(printSection);
  //     document.head.removeChild(printStyles);
  //   };
  // };







// PRINT PAGE WITH WATER MARK(DATE 28/02/2026)
  // PRINT PAGE WITH WATER MARK
  // const handleSaveAndPrint = () => {
  //   const exportData = sortedData.map((row) =>
  //     visibleColumns.map((column) => row[headers.indexOf(column)])
  //   );

  //   // Get current date and user info 
  //   const currentDate = new Date();
  //   const formattedDate = currentDate.toLocaleDateString('en-GB', {
  //     year: 'numeric',
  //     month: '2-digit',
  //     day: '2-digit'
  //   });
  //   const formattedTime = currentDate.toLocaleTimeString('en-US', {
  //     hour: 'numeric',
  //     minute: '2-digit',
  //     hour12: true
  //   });
  //   const formattedDateTime = `${formattedDate}, ${formattedTime}`;

  //   const availablePageHeight = 630; // Adjusted height for A4/Letter
  //   const headerHeight = 150;
  //   const footerHeight = 50;
  //   const rowHeight = 20;
  //   const pageHeightForData = availablePageHeight - headerHeight - footerHeight;
  //   const rowsPerPage = Math.floor(pageHeightForData / rowHeight);

  //   const totalPages = Math.ceil(sortedData.length / rowsPerPage);


  //   const photoColIndex = visibleColumns.indexOf("Photo");

  //   const renderPrintCell = (cell, colIdx) => {
  //     if (colIdx === photoColIndex) {
  //       const isValidUrl =
  //         cell &&
  //         cell !== "---" &&
  //         (cell.startsWith("http://") || cell.startsWith("https://"));
  //       if (isValidUrl) {
  //         return `<td style="text-align:center;padding:4px;">
  //           <img src="${cell}" alt="Photo"
  //             style="width:40px;height:40px;object-fit:cover;border-radius:50%;"
  //             onerror="this.style.display='none';this.nextSibling.style.display='flex';" />
  //           <div style="display:none;width:40px;height:40px;background:#e0e0e0;border-radius:50%;
  //             align-items:center;justify-content:center;font-size:8px;color:#666;text-align:center;
  //             flex-direction:column;margin:auto;">
  //             <span>No</span><span>Photo</span>
  //           </div>
  //         </td>`;
  //       } else {
  //         return `<td style="text-align:center;padding:4px;">
  //           <div style="width:40px;height:40px;background:#e0e0e0;border-radius:50%;
  //             display:flex;align-items:center;justify-content:center;font-size:8px;
  //             color:#666;text-align:center;flex-direction:column;margin:auto;">
  //             <span>No</span><span>Photo</span>
  //           </div>
  //         </td>`;
  //       }
  //     }
  //     return `<td>${cell !== null && cell !== undefined ? cell : ''}</td>`;
  //   };

  //   // Create a hidden print section in the body of the document
  //   const printSection = document.createElement('div');
  //   printSection.id = 'printSection';

  //   // Define print content with scaled styles for A4/Letter and watermark
  //   let printContent = `
  //     <style>
  //       body { margin: 0; padding: 0; font-family: 'Calibri', sans-serif; }
  //       table { width: 100%; border-collapse: collapse; table-layout: fixed; background-color: rgba(255, 255, 255, 0.5); font-size: 10px; margin-top: 6mm; }
  //       th, td { border: 1px solid black; padding: 4px; text-align: center; word-wrap: break-word; font-size: 10px; word-break: break-all; }
  //       th { font-size: 11px; font-weight: bold; background-color: #f2f2f2; }
  //       .Heading-tc { background-color: #f2f2f2; }
  //       .header-container { display: flex; justify-content: space-between; align-items: end; margin-bottom: 14px; border-bottom: 1.6px solid #424242; }
  //       .center-header { text-align: center; font-size: 18px; font-weight: bold; flex-grow: 1; color: #424242; }
  //       .logo { width: 200px; height: auto; margin-top: 10px; }
  //       .right-info { font-size: 10px; }
  //       .course-title  { font-size: 14px; }
  //       .username { text-transform: uppercase; }
  //       .title-container p { margin-top: 1mm; }
  //       .title-label { color: #424242; font-size: 14px; }
  //       .photo-col { width: 55px; }
  //       .transparent-table { background-color: rgba(255, 255, 255, 0.5); }
  //       footer { position: fixed; bottom: 0; width: 100%; text-align: right; font-size: 10px; }
  //       .watermark {
  //         position: fixed;
  //         top: 50%; 
  //         left: 50%;
  //         transform: translate(-50%, -50%);
  //         font-size: 48px;
  //         color: red; 
  //         z-index: -1;
  //         pointer-events: none;
  //         opacity: 0.1;
  //       }
  //       .watermark img{width: auto; height: 200px;}
  //       @media print {
  //         body * { visibility: hidden; }
  //         #printSection, #printSection * { visibility: visible; }
  //         #printSection { position: absolute; left: 0; top: 0; width: 100%; padding: 10mm; }
  //       }
  //       @page { size: auto; margin: 5mm; }
  //     </style>
  //   `;

  //   printContent += `<div class="watermark"><img src="${watermarkImg}" alt="Watermark" /></div>`;

  //   // Generate first page content
  //   printContent += `
  //     <div class="first-page" style="page-break-after: always;">
  //       <div class="header-container">
  //         <img class="logo" src="${reportImg}" alt="Logo" />
  //         <h1 class="center-header">${ReportPageHeader}</h1>
  //         <div class="right-info">
  //           <p>Print Date&nbsp;&nbsp;: ${formattedDateTime}</p>
  //           <p>Printed By&nbsp;: <span class="username">${userName}</span></p>
  //           <p>Page 1 of ${totalPages}</p>
  //         </div>
  //       </div>
  //       <div class="title-container">
  //         <p><span class="title-label">Course:</span><span class="course-title"> ${course}</span></p>
  //         <p><span class="title-label">Batch:</span><span class="course-title"> ${batch}</span></p>
  //         ${subject ? `<p><span class="title-label">Subject:</span><span class="course-title"> ${subject}</span></p>` : ''}
  //         ${chapter ? `<p><span class="title-label">Chapter:</span><span class="course-title"> ${chapter}</span></p>` :  ''}
  //         ${student ? `<p><span class="title-label">Student:</span><span class="course-title"> ${student}</span></p>` : ''}
  //         ${dppName ? `<p><span class="title-label">DPP Name:</span><span class="course-title"> ${dppName}</span></p>` : ''} 
  //         ${feedback ? `<p><span class="title-label">Feedback:</span><span class="course-title"> ${feedback}</span></p>`: ''}
  //         ${test ? `<p><span class="title-label">Test:</span><span class="course-title"> ${test}</span></p>`: ''}
  //         ${date ? `<p><span class="title-label">Date:</span><span class="course-title"> ${date}</span></p>` : ''}
  //       </div>
  //       <table class="transparent-table">
  //         <thead>
  //           <tr>${visibleColumns.map((heading) => `<th class="Heading-tc">${heading}</th>`).join('')}</tr>
  //         </thead>
  //         <tbody>
  //           ${exportData.slice(0, rowsPerPage).map((row) =>
  //          `<tr>${row.map((cell, colIdx) => renderPrintCell(cell, colIdx)).join('')}</tr>`).join('')}
  //         </tbody>
  //       </table>
  //     </div>
  //   `;

  //   // Additional pages
  //   for (let page = 2; page <= totalPages; page++) {
  //     const startIndex = (page - 1) * rowsPerPage;
  //     const endIndex = Math.min(startIndex + rowsPerPage, exportData.length);

  //     printContent += `
  //     <div class="other-pages" style="page-break-after: always;">
  //       <div class="header-container">
  //         <img class="logo" src="${reportImg}" alt="Logo" />
  //         <h1 class="center-header">${ReportPageHeader}</h1>
  //         <div class="right-info">
  //           <p>Print Date&nbsp;&nbsp;: ${formattedDateTime}</p>
  //           <p>Printed By&nbsp;: <span class="username">${userName}</span></p>
  //           <p>Page ${page} of ${totalPages}</p>
  //         </div>
  //       </div>
  //       <table class="transparent-table">
  //         <thead>
  //           <tr>${visibleColumns.map((heading) => `<th class="Heading-tc">${heading}</th>`).join('')}</tr>
  //         </thead>
  //         <tbody>
  //         ${exportData.slice(startIndex, endIndex).map((row) =>
  // `<tr>${row.map((cell, colIdx) => renderPrintCell(cell, colIdx)).join('')}</tr>`).join('')}
  //         </tbody>
  //       </table>
  //     </div>
  //     `;
  //   }

  //   printSection.innerHTML = printContent;

  //   // Append this hidden section to the body
  //   document.body.appendChild(printSection);

  //   // Create a print media query to show only this section during printing
  //   const printStyles = document.createElement('style');
  //   printStyles.innerHTML = `
  //     @media print {
  //       body * { visibility: hidden; }
  //       #printSection, #printSection * { visibility: visible; }
  //       #printSection { position: absolute; left: 0; top: 0; width: 100%; padding: 10mm; }
  //     }

  //     @page {
  //       size: auto;
  //       margin: 5mm;
  //     }
  //   `;
  //   document.head.appendChild(printStyles);

  //   const logo = new Image();
  //   logo.src = reportImg;
  //   logo.onload = () => {
  //     window.print();

  //     // Clean up after printing
  //     document.body.removeChild(printSection);
  //     document.head.removeChild(printStyles);
  //   };
  // };





  // if (column === "Photo") {
                      //   const isValidUrl =
                      //     cellValue &&
                      //     cellValue !== "---" &&
                      //     (cellValue.startsWith("http://") || cellValue.startsWith("https://"));

                      //   return (
                      //     <td
                      //       key={column}
                      //       style={{ textAlign: "center", color: "#6A6A6A", padding: "6px 4px" }}
                      //     >
                      //       <div className="student-avatar-wrapper"
                      //        style={{ cursor: "pointer" }}
                      //         // onClick={() => navigate(`/student_dashboard/${row[headers.indexOf("Student ID")]}`)}
                      //         onClick={() => navigate("/student_dashboard", {
                      //           state: { studentId: row[headers.indexOf("Roll No")] }
                      //         })}
                      //         title="View student dashboard"
                      //         >
                      //         {isValidUrl ? (
                      //           <>
                      //             <img
                      //               src={cellValue}
                      //               alt="Student"
                      //               className="student-avatar"
                      //               onError={(e) => {
                      //                 e.currentTarget.style.display = "none";
                      //                 e.currentTarget.nextSibling.style.display = "flex";
                      //               }}
                      //             />
                      //             <div className="student-avatar-placeholder" style={{ display: "none" }}>
                      //               <span>No</span><span>Photo</span>
                      //             </div>
                      //           </>
                      //         ) : (
                      //           <div className="student-avatar-placeholder">
                      //             <span>No</span><span>Photo</span>
                      //           </div>
                      //         )}
                      //       </div>
                      //     </td>
                      //   );
                      // }


























// code with rows
// const handleSaveAndPrint = () => {
//   const exportData = sortedData.map((row) =>
//     visibleColumns.map((column) => row[headers.indexOf(column)])
//   );

//   // Get current date and user info 
//   const currentDate = new Date();
//   const formattedDate = currentDate.toLocaleDateString('en-GB', {
//     year: 'numeric',
//     month: '2-digit',
//     day: '2-digit'
//   });
//   const formattedTime = currentDate.toLocaleTimeString('en-US', {
//     hour: 'numeric',
//     minute: '2-digit',
//     hour12: true
//   });
//   const formattedDateTime = `${formattedDate}, ${formattedTime}`;

//   const headerHeight = 150;
//   const footerHeight = 50;
//   const rowHeight = 20;

//   // Define the number of rows per page for portrait and landscape
//   const rowsPerPagePortrait = 39; // Example for portrait
//   const rowsPerPageLandscape = 10; // Example for landscape

//   // Determine if we should use landscape or portrait
//   const orientation = visibleColumns.length > 7 ? 'landscape' : 'portrait';
//   const rowsPerPage = orientation === 'landscape' ? rowsPerPageLandscape : rowsPerPagePortrait;

//   const totalPages = Math.ceil(sortedData.length / rowsPerPage);

//   // Create a hidden print section in the body of the document
//   const printSection = document.createElement('div');
//   printSection.id = 'printSection';

//   // Define print content with scaled styles for A4/Letter and watermark
//   let printContent = `
//     <style>
//       body { margin: 0; padding: 0; font-family: 'Calibri', sans-serif; }
//       table { width: 100%; border-collapse: collapse; table-layout: fixed; background-color: rgba(255, 255, 255, 0.5); font-size: 10px; margin-top: 6mm; }
//       th, td { border: 1px solid black; padding: 4px; text-align: center; word-wrap: break-word; font-size: 10px; word-break: break-all; }
//       th { font-size: 11px; font-weight: bold; background-color: #f2f2f2; }
//       .Heading-tc { background-color: #f2f2f2; }
//       .header-container { display: flex; justify-content: space-between; align-items: end; margin-bottom: 14px; border-bottom: 1.6px solid #424242; }
//       .center-header { text-align: center; font-size: 18px; font-weight: bold; flex-grow: 1; color: #424242; }
//       .logo { width: 200px; height: auto; margin-top: 10px; }
//       .right-info { font-size: 10px; }
//       .course-title  { font-size: 14px; }
//       .username { text-transform: uppercase; }
//       .title-container p { margin-top: 1mm; }
//       .title-label { color: #424242; font-size: 14px; }
//       .transparent-table { background-color: rgba(255, 255, 255, 0.5); }
//       footer { position: fixed; bottom: 0; width: 100%; text-align: right; font-size: 10px; }
//       .watermark {
//         position: fixed;
//         top: 50%; 
//         left: 50%;
//         transform: translate(-50%, -50%);
//         font-size: 48px;
//         color: red; 
//         z-index: -1;
//         pointer-events: none;
//         opacity: 0.1;
//       }
//       .watermark img{width: auto; height: 200px;}
//       @media print {
//         body * { visibility: hidden; }
//         #printSection, #printSection * { visibility: visible; }
//         #printSection { position: absolute; left: 0; top: 0; width: 100%; padding: 10mm; }
//       }
//       @page { size: A4 ${orientation}; margin: 5mm; }
//     </style>
//   `;

//   printContent += `<div class="watermark"><img src="${watermarkImg}" alt="Watermark" /></div>`;

//   // Generate first page content
//   printContent += `
//     <div class="first-page" style="page-break-after: always;">
//       <div class="header-container">
//         <img class="logo" src="${reportImg}" alt="Logo" />
//         <h1 class="center-header">${ReportPageHeader}</h1>
//         <div class="right-info">
//           <p>Print Date&nbsp;&nbsp;: ${formattedDateTime}</p>
//           <p>Printed By&nbsp;: <span class="username">${userName}</span></p>
//           <p>Page 1 of ${totalPages}</p>
//         </div>
//       </div>
//       <div class="title-container">
//         <p><span class="title-label">Course:</span><span class="course-title"> ${course}</span></p>
//         <p><span class="title-label">Batch:</span><span class="course-title"> ${batch}</span></p>
//         ${subject ? `<p><span class="title-label">Subject:</span><span class="course-title"> ${subject}</span></p>` : ''}
//         ${chapter ? `<p><span class="title-label">Chapter:</span><span class="course-title"> ${chapter}</span></p>` :  ''}
//         ${student ? `<p><span class="title-label">Student:</span><span class="course-title"> ${student}</span></p>` : ''}
//         ${dppName ? `<p><span class="title-label">DPP Name:</span><span class="course-title"> ${dppName}</span></p>` : ''} 
//         ${feedback ? `<p><span class="title-label">Feedback:</span><span class="course-title"> ${feedback}</span></p>`: ''}
//         ${test ? `<p><span class="title-label">Test:</span><span class="course-title"> ${test}</span></p>`: ''}
//         ${date ? `<p><span class="title-label">Date:</span><span class="course-title"> ${date}</span></p>` : ''}
//       </div>
//       <table class="transparent-table">
//         <thead>
//           <tr>${visibleColumns.map((heading) => `<th class="Heading-tc">${heading}</th>`).join('')}</tr>
//         </thead>
//         <tbody>
//           ${exportData.slice(0, rowsPerPage).map((row) =>
//     `<tr>${row.map((cell) => `<td>${cell !== null ? cell : ''}</td>`).join('')}</tr>`).join('')}
//         </tbody>
//       </table>
//     </div>
//   `;

//   // Additional pages
//   for (let page = 2; page <= totalPages; page++) {
//     const startIndex = (page - 1) * rowsPerPage;
//     const endIndex = Math.min(startIndex + rowsPerPage + 4, exportData.length);

//     printContent += `
//     <div class="other-pages" style="page-break-after: always;">
//       <div class="header-container">
//         <img class="logo" src="${reportImg}" alt="Logo" />
//         <h1 class="center-header">${ReportPageHeader}</h1>
//         <div class="right-info">
//           <p>Print Date&nbsp;&nbsp;: ${formattedDateTime}</p>
//           <p>Printed By&nbsp;: <span class="username">${userName}</span></p>
//           <p>Page ${page} of ${totalPages}</p>
//         </div>
//       </div>
//       <table class="transparent-table">
//         <thead>
//           <tr>${visibleColumns.map((heading) => `<th class="Heading-tc">${heading}</th>`).join('')}</tr>
//         </thead>
//         <tbody>
//           ${exportData.slice(startIndex, endIndex).map((row) =>
//       `<tr>${row.map((cell) => `<td>${cell !== null ? cell : ''}</td>`).join('')}</tr>`).join('')}
//         </tbody>
//       </table>
//     </div>
//     `;
//   }

//   printSection.innerHTML = printContent;

//   // Append this hidden section to the body
//   document.body.appendChild(printSection);

//   // Create a print media query to show only this section during printing
//   const printStyles = document.createElement('style');
//   printStyles.innerHTML = `
//     @media print {
//       body * { visibility: hidden; }
//       #printSection, #printSection * { visibility: visible; }
//       #printSection { position: absolute; left: 0; top: 0; width: 100%; padding: 10mm; }
//     }

//     @page {
//       size: A4 ${orientation};
//       margin: 5mm;
//     }
//   `;
//   document.head.appendChild(printStyles);

//   const logo = new Image();
//   logo.src = reportImg;
//   logo.onload = () => {
//     window.print();

//     // Clean up after printing
//     document.body.removeChild(printSection);
//     document.head.removeChild(printStyles);
//   };
// };





// const handleSaveAndPrint = () => {
//   const exportData = sortedData.map((row) =>
//     visibleColumns.map((column) => row[headers.indexOf(column)])
//   );

//   // Get current date and user info
//   const currentDate = new Date();
//   const formattedDate = currentDate.toLocaleDateString('en-GB', {
//     year: 'numeric',
//     month: '2-digit',
//     day: '2-digit'
//   });
//   const formattedTime = currentDate.toLocaleTimeString('en-US', {
//     hour: 'numeric',
//     minute: '2-digit',
//     hour12: true
//   });
//   const formattedDateTime = `${formattedDate}, ${formattedTime}`;

//   const headerHeight = 150;  // Space reserved for the header
//   const footerHeight = 50;   // Space reserved for the footer  

//   // Define page size for portrait and landscape (in mm)
//   const portraitPageHeight = 297;  // A4 height in mm for portrait
//   const landscapePageHeight = 210; // A4 height in mm for landscape

//   // Determine if we should use landscape or portrait
//   const orientation = visibleColumns.length > 7 ? 'landscape' : 'portrait';

//   // Convert mm to pixels for height calculation
//   const pixelsPerMm = 3.78; // Approximate value (96 DPI)

//   // Calculate available space for data depending on orientation
//   const availablePageHeight =
//     (orientation === 'landscape' ? landscapePageHeight : portraitPageHeight) * pixelsPerMm -
//     headerHeight -
//     footerHeight;

//   // Create a hidden off-screen section to calculate the height dynamically
//   const measurementSection = document.createElement('div');
//   measurementSection.style.position = 'absolute';
//   measurementSection.style.visibility = 'hidden';
//   measurementSection.style.height = 'auto';
//   measurementSection.style.width = 'auto';
//   document.body.appendChild(measurementSection);

//   let totalHeightUsed = 0;
//   let rowsPerPage = 0;
//   const rowHeights = [];

//   // Dynamically measure the row heights based on content
//   exportData.every((row, index) => {
//     const rowElement = document.createElement('div');
//     rowElement.style.width = '100%';
//     rowElement.style.fontSize = '10px'; // Assuming this is the font size used in the table
//     rowElement.innerHTML = row.map((cell) => `<div style="display: inline-block; width: ${100 / visibleColumns.length}%;">${cell || ''}</div>`).join('');

//     measurementSection.appendChild(rowElement);
//     const rowHeight = rowElement.offsetHeight; // Measure the height
//     rowHeights.push(rowHeight);

//     totalHeightUsed += rowHeight;

//     if (totalHeightUsed < availablePageHeight) {
//       rowsPerPage++;
//       return true; // Continue looping
//     } else {
//       return false; // Stop when the page height is reached
//     }
//   });

//   // Remove the measurement section after height calculation
//   document.body.removeChild(measurementSection);

//   const totalPages = Math.ceil(sortedData.length / rowsPerPage);

//   // Create a hidden print section in the body of the document
//   const printSection = document.createElement('div');
//   printSection.id = 'printSection';

//   // Define print content with scaled styles for A4/Letter and watermark
//   let printContent = `
//     <style>
//       body { margin: 0; padding: 0; font-family: 'Calibri', sans-serif; }
//       table { width: 100%; border-collapse: collapse; table-layout: fixed; background-color: rgba(255, 255, 255, 0.5); font-size: 10px; margin-top: 6mm; }
//       th, td { border: 1px solid black; padding: 4px; text-align: center; word-wrap: break-word; font-size: 10px; word-break: break-all; }
//       th { font-size: 11px; font-weight: bold; background-color: #f2f2f2; }
//       .Heading-tc { background-color: #f2f2f2; }
//       .header-container { display: flex; justify-content: space-between; align-items: end; margin-bottom: 14px; border-bottom: 1.6px solid #424242; }
//       .center-header { text-align: center; font-size: 18px; font-weight: bold; flex-grow: 1; color: #424242; }
//       .logo { width: 200px; height: auto; margin-top: 10px; }
//       .right-info { font-size: 10px; }
//       .course-title  { font-size: 14px; }
//       .username { text-transform: uppercase; }
//       .title-container p { margin-top: 1mm; }
//       .title-label { color: #424242; font-size: 14px; }
//       .transparent-table { background-color: rgba(255, 255, 255, 0.5); }
//       footer { position: fixed; bottom: 0; width: 100%; text-align: right; font-size: 10px; }
//       .watermark {
//         position: fixed;
//         top: 50%; 
//         left: 50%;
//         transform: translate(-50%, -50%);
//         font-size: 48px;
//         color: red; 
//         z-index: -1;
//         pointer-events: none;
//         opacity: 0.1;
//       }
//       .watermark img{width: auto; height: 200px;}
//       @media print {
//         body * { visibility: hidden; }
//         #printSection, #printSection * { visibility: visible; }
//         #printSection { position: absolute; left: 0; top: 0; width: 100%; padding: 10mm; }
//       }
//       @page { size: A4 ${orientation}; margin: 5mm; }
//     </style>
//   `;

//   printContent += `<div class="watermark"><img src="${watermarkImg}" alt="Watermark" /></div>`;

//   // Generate first page content (includes logo, title, etc.)
//   printContent += `
//     <div class="first-page" style="page-break-after: always;">
//       <div class="header-container">
//         <img class="logo" src="${reportImg}" alt="Logo" />
//         <h1 class="center-header">${ReportPageHeader}</h1>
//         <div class="right-info">
//           <p>Print Date&nbsp;&nbsp;: ${formattedDateTime}</p>
//           <p>Printed By&nbsp;: <span class="username">${userName}</span></p>
//           <p>Page 1 of ${totalPages}</p>
//         </div>
//       </div>
//       <div class="title-container">
//         <p><span class="title-label">Course:</span><span class="course-title"> ${course}</span></p>
//         <p><span class="title-label">Batch:</span><span class="course-title"> ${batch}</span></p>
//         ${subject ? `<p><span class="title-label">Subject:</span><span class="course-title"> ${subject}</span></p>` : ''}
//         ${chapter ? `<p><span class="title-label">Chapter:</span><span class="course-title"> ${chapter}</span></p>` : ''}
//         ${student ? `<p><span class="title-label">Student:</span><span class="course-title"> ${student}</span></p>` : ''}
//         ${dppName ? `<p><span class="title-label">DPP Name:</span><span class="course-title"> ${dppName}</span></p>` : ''} 
//         ${feedback ? `<p><span class="title-label">Feedback:</span><span class="course-title"> ${feedback}</span></p>`: ''}
//         ${test ? `<p><span class="title-label">Test:</span><span class="course-title"> ${test}</span></p>`: ''}
//         ${date ? `<p><span class="title-label">Date:</span><span class="course-title"> ${date}</span></p>` : ''}
//       </div>
//       <table class="transparent-table">
//         <thead>
//           <tr>${visibleColumns.map((heading) => `<th class="Heading-tc">${heading}</th>`).join('')}</tr>
//         </thead>
//         <tbody>
//           ${exportData.slice(0, rowsPerPage).map((row, index) =>
//     `<tr style="height:${rowHeights[index]}px;">${row.map((cell) => `<td>${cell !== null ? cell : ''}</td>`).join('')}</tr>`).join('')}
//         </tbody>
//       </table>
//     </div>
//   `;

//   // Additional pages
//   for (let page = 2; page <= totalPages; page++) {
//     const startIndex = (page - 1) * rowsPerPage;
//     const endIndex = Math.min(startIndex + rowsPerPage, exportData.length);

//     printContent += `
//     <div class="other-pages" style="page-break-after: always;">
//       <div class="header-container">
//         <img class="logo" src="${reportImg}" alt="Logo" />
//         <h1 class="center-header">${ReportPageHeader}</h1>
//         <div class="right-info">
//           <p>Print Date&nbsp;&nbsp;: ${formattedDateTime}</p>
//           <p>Printed By&nbsp;: <span class="username">${userName}</span></p>
//           <p>Page ${page} of ${totalPages}</p>
//         </div>
//       </div>
//       <table class="transparent-table">
//         <thead>
//           <tr>${visibleColumns.map((heading) => `<th class="Heading-tc">${heading}</th>`).join('')}</tr>
//         </thead>
//         <tbody>
//           ${exportData.slice(startIndex, endIndex).map((row, index) =>
//       `<tr style="height:${rowHeights[startIndex + index]}px;">${row.map((cell) => `<td>${cell !== null ? cell : ''}</td>`).join('')}</tr>`).join('')}
//         </tbody>
//       </table>
//     </div>
//     `;
//   }

//   printSection.innerHTML = printContent;

//   // Append this hidden section to the body
//   document.body.appendChild(printSection);

//   // Trigger print
//   window.print();

//   // Clean up after printing
//   document.body.removeChild(printSection);
// };

















{/* <table class="transparent-table">
          <thead>
            <tr>${visibleColumns.map((heading) => `<th class="Heading-tc">${heading}</th>`).join('')}</tr>
          </thead>
          <tbody>
          ${sortedData.slice(startIndex, endIndex).map((originalRow, idx) => {
            const exportRowIndex = startIndex + idx;
            const exportRow = exportData[exportRowIndex];
            return `<tr>${exportRow.map((cell, colIdx) => renderPrintCell(cell, colIdx, originalRow)).join('')}</tr>`;
          }).join('')}
          </tbody>
        </table> */}
